import { StrictMode } from "react";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import { RouterProvider } from "@tanstack/react-router";
import { createRoot } from "react-dom/client";

import { ThemeProvider } from "@/components/theme/theme-provider";
import {
  getPosthogClient,
  initAnalytics,
  isAnalyticsEnabled,
} from "@/lib/analytics";
import { router } from "@/router";

import "./index.css";

initAnalytics();

const app = (
  <ThemeProvider>
    <RouterProvider router={router} />
  </ThemeProvider>
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isAnalyticsEnabled() ? (
      <PostHogProvider client={getPosthogClient()}>
        <PostHogErrorBoundary
          fallback={
            <p className="p-4 text-center text-sm text-muted-foreground">
              Something went wrong. Refresh the page to try again.
            </p>
          }
        >
          {app}
        </PostHogErrorBoundary>
      </PostHogProvider>
    ) : (
      app
    )}
  </StrictMode>,
);
